import { useEffect, useMemo, useState } from "react";
import {
  Modal,
  Button,
  Label,
  TextInput,
  Textarea,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "flowbite-react";

export default function AuctionRuleTemplateFormModal({
  open,
  onClose,
  initialData,
  saving,
  onSubmit,
}) {
  const isEdit = !!initialData?.id;

  const defaults = useMemo(
    () => ({
      title: "",
      rules_text: "",
    }),
    [],
  );

  const [form, setForm] = useState(defaults);
  const [touched, setTouched] = useState({});

  useEffect(() => {
    if (!open) return;

    if (!initialData) {
      setForm(defaults);
      setTouched({});
      return;
    }

    setForm({
      title: initialData.title ?? "",
      rules_text: initialData.rules_text ?? "",
    });
    setTouched({});
  }, [open, initialData, defaults]);

  const errors = {
    title: !form.title?.trim() ? "Obrigatório" : null,
    rules_text: !form.rules_text?.trim() ? "Obrigatório" : null,
  };

  const hasErrors = !!(errors.title || errors.rules_text);

  function setField(key, value) {
    setForm((s) => ({ ...s, [key]: value }));
  }

  function markTouched(key) {
    setTouched((t) => ({ ...t, [key]: true }));
  }

  function handleSave() {
    setTouched({ title: true, rules_text: true });
    if (hasErrors) return;

    const payload = {
      title: form.title.trim(),
      rules_text: form.rules_text.trim(),
    };

    onSubmit(payload);
  }

  return (
    <Modal show={open} onClose={onClose}>
      <ModalHeader>{isEdit ? "Editar Template" : "Nova Template"}</ModalHeader>

      <ModalBody>
        <div className="space-y-4">
          <div>
            <Label htmlFor="title" value="Title" />
            <TextInput
              id="title"
              value={form.title}
              onChange={(e) => setField("title", e.target.value)}
              onBlur={() => markTouched("title")}
              placeholder="Ex: Florida - Tax Deed (geral)"
              color={touched.title && errors.title ? "failure" : "gray"}
              helperText={touched.title && errors.title ? errors.title : null}
              disabled={saving === true}
            />
          </div>

          <div>
            <Label htmlFor="rules_text" value="Rules Text" />
            <Textarea
              id="rules_text"
              rows={10}
              value={form.rules_text}
              onChange={(e) => setField("rules_text", e.target.value)}
              onBlur={() => markTouched("rules_text")}
              placeholder="Cole aqui as regras em texto..."
              disabled={saving === true}
            />
            {touched.rules_text && errors.rules_text ? (
              <p className="mt-1 text-sm text-red-600">{errors.rules_text}</p>
            ) : null}
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          className="text-slate-600"
          onClick={handleSave}
          disabled={saving === true}
        >
          {saving === true ? "Salvando..." : "Salvar"}
        </Button>
        <Button color="gray" onClick={onClose} disabled={saving === true}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
